import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { safeRedirectUrl } from 'app/core/auth/redirect-url';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
  route,
  state,
) => {
  const router: Router = inject(Router);

  // Check the authentication status
  return inject(AuthService)
    .check()
    .pipe(
      switchMap((authenticated) => {
        // If the user is authenticated...
        if (authenticated) {
          // Send them where they were going, not where this page happens to
          // be. `AuthGuard` attaches `redirectURL` before bouncing anyone here,
          // and a session that turns out to be live on the second look — a
          // cold tab whose `check()` had not finished yet — arrives with that
          // parameter still in hand. Discarding it (this used to `parseUrl('')`
          // unconditionally) stranded every deep link on the project list.
          const redirectURL = route.queryParamMap.get('redirectURL');

          return of(router.parseUrl(safeRedirectUrl(redirectURL, '')));
        }

        // Allow the access
        return of(true);
      }),
    );
};
